/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Styled as MenuIconStyled } from '../../layout/header/menu-icon/styles';
import { getCommandIntelligenceTokens } from '../../theme/commandIntelligenceTokens';

export const StyledCommandIntelligenceHeaderButton = styled(MenuIconStyled)(({ theme }) => {
  const tokens = getCommandIntelligenceTokens(theme);

  return css`
    color: ${tokens.accentIntelligence};
  `;
});
